import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "material-ui/Button";
import {
  deviceList,
  adapterAssetList,
  addDevice,
  deleteDevice,
  deleteAdapterAsset,
  deviceVNC,
  searchDeviceDetails,
  resetDeviceDetails,
  deviceTypeList, updateDeviceLockStatus
} from "../../redux/actions";

import Devices from "../../components/devices";
import AdapterAssetsPanel from "../../components/adapter-assets";
import IdealAdminDevices from "../../components/device/idealAdminDevices";
import { preparePager, prepareSearch } from "../../common/tabletools";

const safeTranslate = (translate, key, fallback) =>
  typeof translate === "function" ? translate(key) : fallback;

const getSelectedViewFromSearch = search => {
  const params = new URLSearchParams(search);
  return params.get("view") === "adapters" ? "adapters" : "devices";
};

class DevicesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pager: {
        defaultColumns: [
          "deviceserialno",
          "systemdevicetype",
          "lastonline",
          "engineer",
          "calibrationdue",
          "totaltest",
          "softwareversion"
        ],
        manual: true,
        pageno: 1,
        pagesize: 10,
        order: {},
        search: [],
        global: false
      },
      selectedView: getSelectedViewFromSearch(props.location.search),
      isIdealAdmin: !!(
        props.profile &&
        props.profile.roles &&
        (props.profile.roles === "idealadmin" || props.profile.roles === "idealsupport")
      )
    };
  }

  render() {
    const {
      translate,
      devices,
      adapterAssets,
      addDevice,
      deleteDevice,
      deleteAdapterAsset,
      user,
      deviceVNC,
      searchDeviceDetails,
      device,
      resetDeviceDetails,
      deviceTypes,
      updateDeviceLockStatus
    } = this.props;

    const { pager, isIdealAdmin, selectedView } = this.state;
    const hasLrpFreeFeatures = this.props.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features');
    const viewSwitcher = hasLrpFreeFeatures ? this.renderViewSwitcher(selectedView, translate) : null;

    return isIdealAdmin ? (
      <IdealAdminDevices
        translate={translate}
        isIdealAdmin={isIdealAdmin}
        searchDeviceDetails={searchDeviceDetails}
        device={device || {}}
        resetDeviceDetails={resetDeviceDetails}
      />
    ) : selectedView === "devices" && devices ? (
      <React.Fragment>
        <Devices
          translate={translate}
          devices={devices}
          adapterAssets={adapterAssets}
          pager={pager}
          fetch={this.fetch}
          search={this.search}
          addDevice={addDevice}
          deleteDevice={deleteDevice}
          deviceVNC={deviceVNC}
          user={user}
          deviceTypes={deviceTypes}
          refresh={this.refresh}
          viewSwitcher={viewSwitcher}
          updateDeviceLockStatus={updateDeviceLockStatus}
          hasLrpFreeFeatures={hasLrpFreeFeatures}
          key={hasLrpFreeFeatures ? 'lrp-free-features' : 'standard'}
        />
      </React.Fragment>
    ) : selectedView === "adapters" && hasLrpFreeFeatures ? (
      <AdapterAssetsPanel
        translate={translate}
        adapterAssets={adapterAssets}
        deleteAdapterAsset={deleteAdapterAsset}
        viewSwitcher={viewSwitcher}
      />
    ) : null;
  }

  componentDidMount() {
    const { isIdealAdmin } = this.state;
    if (!isIdealAdmin) {
      this.props.deviceList(this.state.pager);
      if (this.props.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features')) {
        this.props.adapterAssetList();
      }
      this.props.deviceTypeList();
    }
  }

  componentDidUpdate(prevProps) {
    const hasLrpFreeFeatures = this.props.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features');
    const hadLrpFreeFeatures = prevProps.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features');
    if (hasLrpFreeFeatures && !hadLrpFreeFeatures) {
      this.props.adapterAssetList();
    }

    if (this.props.appSettingsLoaded && !hasLrpFreeFeatures && this.state.selectedView === 'adapters') {
      this.props.history.replace('/devices');
      return;
    }

    if (prevProps.location.search !== this.props.location.search) {
      const selectedView = getSelectedViewFromSearch(this.props.location.search);
      if (selectedView !== this.state.selectedView && (selectedView !== 'adapters' || hasLrpFreeFeatures)) {
        this.setState({ selectedView });
      }
    }
  }

  refresh = () => {
    const { deviceList, adapterAssetList } = this.props;
    const { pager } = this.state;
    deviceList(pager);
    if (this.props.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features')) {
      adapterAssetList();
    }
  };

  handleTabChange = (event, selectedView) => {
    if (selectedView === 'adapters' && !this.props.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features')) {
      return;
    }
    if (selectedView === this.state.selectedView) {
      return;
    }

    this.setState({ selectedView });

    const params = new URLSearchParams(this.props.location.search);
    if (selectedView === "adapters") {
      params.set("view", "adapters");
      this.props.adapterAssetList();
    } else {
      params.delete("view");
    }

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: params.toString() ? `?${params.toString()}` : ""
    });
  };

  renderViewSwitcher = (selectedView, translate) => {
    const deviceLabel = safeTranslate(translate, "general_devices", "Devices");
    const adapterLabel = safeTranslate(translate, "adapter_assets_title", "Adapters");
    const sharedButtonStyle = {
      minWidth: 108,
      height: 32,
      borderRadius: 0,
      fontSize: 13,
      fontWeight: 600,
      textTransform: "none"
    };

    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          border: "1px solid rgba(255, 255, 255, 0.45)",
          borderRadius: 18,
          overflow: "hidden",
          marginRight: 12
        }}
      >
        <Button
          style={{
            ...sharedButtonStyle,
            backgroundColor: selectedView === "devices" ? "#fff" : "transparent",
            color: selectedView === "devices" ? "#025794" : "#fff"
          }}
          onClick={() => this.handleTabChange(null, "devices")}
        >
          {deviceLabel}
        </Button>
        <Button
          style={{
            ...sharedButtonStyle,
            backgroundColor: selectedView === "adapters" ? "#fff" : "transparent",
            color: selectedView === "adapters" ? "#025794" : "#fff"
          }}
          onClick={() => this.handleTabChange(null, "adapters")}
        >
          {adapterLabel}
        </Button>
      </div>
    );
  };

  fetch = table => {
    const { pager } = this.state;
    if (!pager.global) this.props.deviceList(preparePager(table, pager));
    else {
      let search = pager.search;
      let pagers = preparePager(table, pager);
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search];
      } else {
        pagers.search = search;
      }
      this.props.deviceList(pagers);
      this.setState({
        pager: pagers
      });
    }
  };

  search = term => {
    const { devices } = this.props;
    const { columns } = devices;
    const { pager } = this.state;

    const _pager = prepareSearch(term, columns, pager);
    _pager.global = term !== "";
    this.setState({
      pager: _pager
    });

    this.props.deviceList(_pager);
  };
}

const mapDispatchToProps = (dispatch, props) => ({
  deviceList: pager => {
    dispatch(deviceList(pager));
  },
  adapterAssetList: search => {
    dispatch(adapterAssetList(search));
  },
  addDevice: (device, pager) => {
    dispatch(addDevice(device, pager));
  },
  deleteDevice: (id, pager) => {
    return dispatch(deleteDevice(id, pager));
  },
  deleteAdapterAsset: id => {
    return dispatch(deleteAdapterAsset(id));
  },
  deviceVNC: () => {
    dispatch(deviceVNC());
  },
  searchDeviceDetails: deviceId => {
    dispatch(searchDeviceDetails(deviceId));
  },
  resetDeviceDetails: () => {
    dispatch(resetDeviceDetails());
  },
  deviceTypeList: () => {
    dispatch(deviceTypeList());
  },
  updateDeviceLockStatus: (id, status) => {
    return dispatch(updateDeviceLockStatus(id, status));
  }
});

const mapStateToProps = state => ({
  devices: state.deviceReducer.devices,
  adapterAssets: state.deviceReducer.adapterAssets,
  user: state.userReducer.user,
  device: state.deviceReducer.device,
  profile: state.profileReducer.profile,
  deviceTypes: state.deviceReducer.deviceTypes,
  activeFeatures: state.appSettingReducer.activeFeatures,
  appSettingsLoaded: !!state.appSettingReducer.lastResponse
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DevicesPage));
